"use client";

import React from "react";
import { createPortal } from "react-dom";

const AppShellHeaderSlotContext = React.createContext<HTMLElement | null>(null);

export function AppShellHeaderSlotProvider({
  slotEl,
  children,
}: {
  slotEl: HTMLElement | null;
  children: React.ReactNode;
}) {
  return (
    <AppShellHeaderSlotContext.Provider value={slotEl}>
      {children}
    </AppShellHeaderSlotContext.Provider>
  );
}

/**
 * Portals toolbar content into the AppShell navbar slot (keeps React state ownership).
 */
export function AppShellHeaderControls({
  children,
}: {
  children: React.ReactNode;
}) {
  const slotEl = React.useContext(AppShellHeaderSlotContext);
  if (!slotEl) return null;
  return createPortal(children, slotEl);
}
